import { FC, useMemo } from "react";
import { Stack, Typography } from "@mui/material";
import { v4 as uuid } from "uuid";
import { useDidMount } from "rooks";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { coverageRecommendationsPayloadSelector } from "@/store/commitments/selectors/coverage-and-utilization/details-drawer/recommendations/coverageRecommendationsPayloadSelector";
import { commitmentsRecommendationsFiltersSelector } from "@/store/commitments/selectors/recommendations/filters/commitmentsRecommendationsFiltersSelector";
import { useGetUsersMeOrganisationsCurrentSavingsPlansRecommendationsQuery } from "@/services/cloudchipr.api";
import { filterSavingsPlansRecommendationsByFilters } from "@/store/commitments/utils/helpers/filterSavingsPlansRecommendationsByFilters";
import { initiateSavingPlansCoverageDrawerThunk } from "@/store/commitments/thunks/recommendations/initiateSavingPlansCoverageDrawerThunk";
import { commitmentsRecommendationsGridColumnDefs } from "@/components/pages/commtiments/utilization-and-coverage/components/content/recommendations/data-grid/commitmentsRecommendationsGridColumnDefs";
import { CommitmentsAgGrid } from "@/components/pages/commtiments/common/components/CommitmentsAgGrid";
import { CoverageDrawerRecommendationsGridToolbar } from "@/components/pages/commtiments/utilization-and-coverage/components/drawers/coverage-drawer/recommendations/CoverageDrawerRecommendationsGridToolbar";

export const SavingsPlanCoverageDrawerRecommendationTab: FC = () => {
  const dispatch = useAppDispatch();

  const payload = useAppSelector(coverageRecommendationsPayloadSelector);
  const filters = useAppSelector(commitmentsRecommendationsFiltersSelector);

  const { data, isLoading } =
    useGetUsersMeOrganisationsCurrentSavingsPlansRecommendationsQuery(payload);

  const filteredData = useMemo(() => {
    return filterSavingsPlansRecommendationsByFilters(
      filters,
      data?.map((recommendation) => ({
        ...recommendation,
        id: uuid(),
      })),
    );
  }, [data, filters]);

  useDidMount(() => {
    dispatch(initiateSavingPlansCoverageDrawerThunk());
  });

  return (
    <Stack py={1.5} height="100%" p={1.5}>
      <CommitmentsAgGrid
        columnDefs={commitmentsRecommendationsGridColumnDefs}
        data={filteredData ?? []}
        Toolbar={CoverageDrawerRecommendationsGridToolbar}
        localStorageUniqueKey="CoverageDrawerRecommendationsSection"
        overrideDefaultColDef={defaultColDef}
        noRowOverlayComponent={NoRowOverlayComponent}
        overrideWrapperStyles={overrideWrapperStyles}
        loading={isLoading}
      />
    </Stack>
  );
};

const defaultColDef = { filter: false };
const overrideWrapperStyles = {
  "& .ag-root-wrapper": {
    borderRadius: 2,
    border: 1,
    borderColor: "grey.300",
  },
};
const NoRowOverlayComponent = () => {
  return (
    <Stack alignItems="center" p={3}>
      <Typography
        variant="subtitle1"
        fontWeight="medium"
        color="text.secondary"
      >
        No Recommendations
      </Typography>
    </Stack>
  );
};
